export default "__VITE_ASSET__CV5Uu$mR__"